<template>
    <div>
        <trax-ui-card-icon-header icon="info_outline" header-color="info" 
            :title="lang.polaris.dashboard.session_information" class="mt-5">

            <form autocomplete="off" class="trax-form mb-4">

                <trax-ui-select-remote-object col="md-3"
                    :placeholder="lang.polaris.dashboard.hdv_select + ' 1'" 
                    v-model="form.flow_id"
                    :error="errors.flow_id"
                    :endpoint="hdvSelectEndpoint"
                    :exclude="selectedFlowIdsExcept(form.flow_id)"
                    @changed="hdvFlowChanged"
                    @initialized="hdvFlowInitialized"
                    :unselectedLabel="lang.polaris.dashboard.hdv_unselected"
                    :noOptionLabel="lang.polaris.dashboard.hdv_no_option"
                    :required="hdvRequired"
                    :unselect="true"
                ></trax-ui-select-remote-object>

                <trax-ui-select-remote-object col="md-3" v-show="form.flow_id"
                    :placeholder="lang.polaris.dashboard.hdv_select + ' 2'" 
                    v-model="form.flow2_id"
                    :error="errors.flow2_id"
                    :endpoint="hdvSelectEndpoint2"
                    :exclude="selectedFlowIdsExcept(form.flow2_id)"
                    @changed="hdvFlow2Changed"
                    @initialized="hdvFlow2Initialized"
                    :unselectedLabel="lang.polaris.dashboard.hdv_unselected"
                    :noOptionLabel="lang.polaris.dashboard.hdv_no_option"
                    :unselect="true"
                ></trax-ui-select-remote-object>

                <trax-ui-select-remote-object col="md-3" v-show="form.flow2_id"
                    :placeholder="lang.polaris.dashboard.hdv_select + ' 3'" 
                    v-model="form.flow3_id"
                    :error="errors.flow3_id"
                    :endpoint="hdvSelectEndpoint3"
                    :exclude="selectedFlowIdsExcept(form.flow3_id)"
                    @changed="hdvFlow3Changed"
                    @initialized="hdvFlow3Initialized"
                    :unselectedLabel="lang.polaris.dashboard.hdv_unselected"
                    :noOptionLabel="lang.polaris.dashboard.hdv_no_option"
                    :unselect="true"
                ></trax-ui-select-remote-object>

                <trax-ui-select col="md-3"
                    :placeholder="lang.polaris.dashboard.location" 
                    v-model="form.entity_id"
                    :error="errors.location"
                    :options="locations_select" 
                    :unselected="lang.polaris.common.no_location"
                    grouped="1"
                    required="1"
                    :disabled="form.flow_id != null && current_flow && current_flow.entity_id"
                ></trax-ui-select>

                <trax-ui-datetime col="md-3"
                    :placeholder="lang.polaris.dashboard.date"
                    v-model="form.date"
                    :error="errors.date"
                    type="date"
                    required="1"
                    :disabled="form.flow_id != null"
                ></trax-ui-datetime>

                <trax-ui-select col="md-3"
                    :placeholder="lang.polaris.common.aircraft_type"
                    v-model="form.aircraft_type"
                    :error="errors.aircraft_type"
                    :options="aircraft_types_select"
                    :unselected="lang.polaris.common.no_aircraft_type"
                    required="1"
                    :disabled="form.flow_id != null && current_flow && current_flow.aircraft_type && !current_flow.unknown_aircraft_type"
                ></trax-ui-select>

                <trax-ui-select col="md-3"
                    :placeholder="lang.polaris.common.aircraft_category"
                    v-model="form.aircraft_category"
                    :error="errors.aircraft_category"
                    :options="aircraft_categories_select"
                    :unselected="lang.polaris.common.no_aircraft_category"
                    required="1"
                    :disabled="form.flow_id != null && current_flow && current_flow.aircraft_category && !current_flow.unknown_aircraft_category"
                ></trax-ui-select>

                <trax-ui-input col="md-3"
                    :placeholder="lang.polaris.common.aircraft_registration"
                    v-model="form.aircraft_registration"
                    :error="errors.aircraft_registration"
                    :disabled="form.flow_id != null"
                ></trax-ui-input>

                <trax-ui-input col="md-3"
                    :placeholder="lang.polaris.dashboard.flight_time"
                    :help="lang.polaris.dashboard.flight_time_help"
                    v-model="form.duration"
                    :error="errors.duration"
                    required="1"
                    :disabled="form.flow_id != null"
                ></trax-ui-input>

                <trax-ui-input col="md-3"
                    :placeholder="lang.polaris.dashboard.tag_landing"
                    v-model="form.tag_landing"
                    :error="errors.tag_landing"
                    required="1"
                    :disabled="form.flow_id != null"
                ></trax-ui-input>

                <trax-ui-select col="md-3"
                    :placeholder="lang.polaris.dashboard.additional_signatory"
                    v-model="form.additional_signatory"
                    :options="signatories_select"
                    :error="errors.additional_signatory"
                    :unselected="lang.polaris.dashboard.no_additional_signatory">
                </trax-ui-select>

                <trax-ui-toggle col="md-3"
                    :text="lang.polaris.dashboard.downgrade_spic_to_dual" 
                    v-model="form.downgrade"
                    v-if="item.meta.crew_type == 'spic'"
                ></trax-ui-toggle>

            </form>
        </trax-ui-card-icon-header>

        <trax-ui-card-icon-header icon="info_outline" header-color="info" 
            :title="lang.polaris.dashboard.solo_session_information" class="mt-5"
            v-if="item.meta.crew_type == 'solo'"
        >
            <form autocomplete="off" class="trax-form mb-4">

                <h6 class="section-title text-center py-2 mb-0" >
                    Limitations
                </h6>
                
                <trax-ui-input col="md-3"
                    placeholder="Visibility"
                    v-model="form.visibility"
                    :error="errors.visibility"
                     required="1"
                ></trax-ui-input>
                
                <trax-ui-input col="md-3"
                    placeholder="Ceiling"
                    v-model="form.ceiling"
                    :error="errors.ceiling"
                     required="1"
                ></trax-ui-input>
                
                <trax-ui-input col="md-3"
                    placeholder="Max Crosswind"
                    v-model="form.max_crosswind"
                    :error="errors.max_crosswind"
                     required="1"
                ></trax-ui-input>
                
                <trax-ui-input col="md-3"
                    placeholder="Max Effective Wind"
                    v-model="form.max_effective_wind"
                    :error="errors.max_effective_wind"
                     required="1"
                ></trax-ui-input>
                
                <trax-ui-input col="md-3"
                    placeholder="Risk Assessment Score"
                    v-model="form.risk_assessment_score"
                    :error="errors.risk_assessment_score"
                     required="1"
                ></trax-ui-input>

                <h6 class="section-title text-center py-2 mt-4 mb-0" >
                    Type of Flight
                </h6>

                <p class="mt-3 text-danger text-center mb-0">
                    <small>Please, select at the minimum one of the following options.</small>
                </p>

                <trax-ui-checkbox col="md-3" text="Manoeuvrability" v-model="form.manoeuvrability">
                </trax-ui-checkbox>

                <trax-ui-checkbox col="md-3" text="Cross Country" v-model="form.cross_country">
                </trax-ui-checkbox>

                <trax-ui-checkbox col="md-3" text="Night" v-model="form.night">
                </trax-ui-checkbox>

                <h6 class="section-title text-center py-2 mt-4 mb-0" >
                    Work to be Completed
                </h6>

                <trax-ui-input type="text" rows="5" col="md-3" placeholder="Work to be Completed"
                    v-model="form.work_to_be_completed" :error="errors.work_to_be_completed"
                    required="1"
                >
                </trax-ui-input>

                <h6 class="section-title text-center py-2 mt-4 mb-0" >
                    Exercises Not Completed
                </h6>

                <trax-ui-input type="text" rows="5" col="md-3" placeholder="Exercises Not Completed"
                    v-model="form.exercises_not_completed" :error="errors.exercises_not_completed">
                </trax-ui-input>

            </form>

        </trax-ui-card-icon-header>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-flight-follow-up-learner-edit'},
            source: {default: '1'},
            target: {default: '2'}
        },

        data: function() {
            return {
                lang: lang,
                item: data.item,
                phase: data.phase,
                signatories_select: data.signatories_select,
                signatories_names_uuid: data.signatories_names_uuid,
                locations_select: data.locations_select,
                locations_names_id: data.locations_names_id,
                locations_uuid_id: data.locations_uuid_id,
                locations_id_uuid: data.locations_id_uuid,
                default_location: data.phase.custom && data.phase.custom.entity_id ? data.phase.custom.entity_id : data.phase.entity_id,
                aircraft_types_select: data.aircraft_types_select,
                aircraft_categories_select: data.aircraft_categories_select,
                form: {
                    flow_id: null,
                    flow2_id: null,
                    flow3_id: null,
                    entity_id: null,
                    date: '',
                    aircraft_type: '',
                    aircraft_category: '',
                    aircraft_registration: '',
                    duration: '',
                    tag_landing: '',
                    additional_signatory: '',
                    // SPIC
                    downgrade: 0,
                    // SOLO
                    visibility: '',
                    ceiling: '',
                    max_crosswind: '',
                    max_effective_wind: '',
                    risk_assessment_score: '',
                    manoeuvrability: 0,
                    cross_country: 0,
                    night: 0,
                    work_to_be_completed: '',
                    exercises_not_completed: '',
                },
                saved_flow_id: null,
                saved_flow2_id: null,
                saved_flow3_id: null,
                current_flow: null,
                current_flow2: null,
                current_flow3: null,
                errors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        computed: {
            hdvSelectEndpoint() {
               return app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners/'+data.learner.id+'/hdv-flows/'+this.saved_flow_id
            },

            hdvSelectEndpoint2() {
               return app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners/'+data.learner.id+'/hdv-flows/'+this.saved_flow2_id
            },

            hdvSelectEndpoint3() {
               return app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners/'+data.learner.id+'/hdv-flows/'+this.saved_flow3_id
            },

            hdvRequired() {
                return this.phase.custom && this.phase.custom.meta.hdv_sync_required
            },
        },

        methods: {

            selectedFlowIdsExcept(flowId) {
                let flowIds = []
                if (this.current_flow && this.current_flow.id != flowId) {
                    flowIds.push(this.current_flow.id)
                }
                if (this.current_flow2 && this.current_flow2.id != flowId) {
                    flowIds.push(this.current_flow2.id)
                }
                if (this.current_flow3 && this.current_flow3.id != flowId) {
                    flowIds.push(this.current_flow3.id)
                }
                return flowIds
            },

            hdvFlowInitialized(flow) {
                this.current_flow = flow
            },

            hdvFlow2Initialized(flow) {
                this.current_flow2 = flow
            },

            hdvFlow3Initialized(flow) {
                this.current_flow3 = flow
            },

            hdvFlowChanged(flow) {
                this.current_flow = flow

                if (flow) {
                    this.form.entity_id = flow.entity_id ? flow.entity_id : null
                    if (flow.aircraft_type) {
                        this.form.aircraft_type = flow.unknown_aircraft_type ? null : 'type_' + flow.aircraft_type
                    }
                    if (flow.aircraft_category) {
                        this.form.aircraft_category = flow.unknown_aircraft_category ? null : 'cat_' + flow.aircraft_category
                    }
                    this.form.aircraft_registration = flow.aircraft_registration
                    this.form.date = moment(flow.flight_timestamp).format('YYYY-MM-DD')
                } else {
                    this.setDefaultForm()
                }


                if (!flow) {
                    this.form.flow2_id = null
                    this.form.flow3_id = null
                    this.current_flow2 = null
                    this.current_flow3 = null
                }

                this.totalizeDurations()
                this.totalizeTagLandings()
            },

            hdvFlow2Changed(flow) {
                this.current_flow2 = flow

                if (!flow) {
                    this.form.flow3_id = null
                    this.current_flow3 = null
                }

                this.totalizeDurations()
                this.totalizeTagLandings()
            },

            hdvFlow3Changed(flow) {
                this.current_flow3 = flow

                this.totalizeDurations()
                this.totalizeTagLandings()
            },

            totalizeDurations() {
                if (!this.current_flow) {
                    this.form.duration = null
                    return
                }
                let duration = this.current_flow.flight_duration
                if (this.current_flow2) {
                    duration += this.current_flow2.flight_duration
                }
                if (this.current_flow3) {
                    duration += this.current_flow3.flight_duration
                }
                this.form.duration = (duration / 60.0).toFixed(2)
            },

            totalizeTagLandings() {
                if (!this.current_flow) {
                    this.form.tag_landing = null
                    return
                }
                let tag_landing = this.current_flow.tag_landing
                if (this.current_flow2) {
                    tag_landing += this.current_flow2.tag_landing
                }
                if (this.current_flow3) {
                    tag_landing += this.current_flow3.tag_landing
                }
                this.form.tag_landing = tag_landing
            },

            setDefaultForm() {
                this.form.entity_id = this.default_location
                this.form.date = '';
                this.form.aircraft_type = this.item.meta.aircraft_type;
                this.form.aircraft_category = this.item.meta.aircraft_category;
                this.form.aircraft_registration = '';
                this.form.duration = '';
                this.form.tag_landing = '';
                this.form.additional_signatory = '';
                // SPIC
                this.form.downgrade = 0;
                // SOLO
                this.form.visibility = ''
                this.form.ceiling = ''
                this.form.max_crosswind = ''
                this.form.max_effective_wind = ''
                this.form.risk_assessment_score = ''
                this.form.manoeuvrability = 0
                this.form.cross_country = 0
                this.form.night = 0
                this.form.work_to_be_completed = ''
                this.form.exercises_not_completed = ''
            },

            setStates(states) {
                if (!states.summary) {

                    this.current_flow = null
                    this.current_flow2 = null
                    this.current_flow3 = null

                    this.saved_flow_id = null
                    this.saved_flow2_id = null
                    this.saved_flow3_id = null

                    this.form.flow_id = null
                    this.form.flow2_id = null
                    this.form.flow3_id = null

                    this.setDefaultForm()

                    return;
                }

                this.saved_flow_id = states.summary.flow_id
                this.saved_flow2_id = states.summary.flow2_id
                this.saved_flow3_id = states.summary.flow3_id

                this.form.flow_id = states.summary.flow_id
                this.form.flow2_id = states.summary.flow2_id
                this.form.flow3_id = states.summary.flow3_id

                if (states.summary.data.location) {
                    this.form.entity_id = this.locations_id_uuid[states.summary.data.location.entity_uuid];
                }
                if (states.summary.data.aircraft_type) {
                    this.form.aircraft_type = states.summary.data.aircraft_type;
                }
                if (states.summary.data.aircraft_category) {
                    this.form.aircraft_category = states.summary.data.aircraft_category;
                }
                if (states.summary.data.aircraft_registration) {
                    this.form.aircraft_registration = states.summary.data.aircraft_registration;
                }
                if (states.summary.data.additional_signatory) {
                    this.form.additional_signatory = states.summary.data.additional_signatory.user_uuid;
                }
                this.form.date = states.summary.data.date;
                this.form.duration = states.summary.data.duration;
                this.form.tag_landing = states.summary.data.tag_landing;
                // SPIC
                this.form.downgrade = states.summary.data.downgrade;
                // SOLO
                this.form.visibility = states.summary.data.visibility
                this.form.ceiling = states.summary.data.ceiling
                this.form.max_crosswind = states.summary.data.max_crosswind
                this.form.max_effective_wind = states.summary.data.max_effective_wind
                this.form.risk_assessment_score = states.summary.data.risk_assessment_score
                this.form.manoeuvrability = states.summary.data.manoeuvrability
                this.form.cross_country = states.summary.data.cross_country
                this.form.night = states.summary.data.night
                this.form.work_to_be_completed = states.summary.data.work_to_be_completed
                this.form.exercises_not_completed = states.summary.data.exercises_not_completed
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {

                // Refuse to sign if the HDV flow is not selected.
                if (this.hdvRequired
                    && data.summary.sign == 'validation'
                    && !this.form.flow_id
                ) {
                    this.bus.$emit(this.id+'-toastr-error', this.lang.polaris.dashboard.hdv_flow_required_for_signing);
                    return
                }

                // Else, prepare final data.
                this.errors = {};
                for (var prop in this.form) { 
                    if (prop == 'entity_id') {
                        data.summary.location = {
                            entity_uuid: this.locations_uuid_id[this.form.entity_id], 
                            entity_name: this.locations_names_id[this.form.entity_id] 
                        };
                    } else if (prop == 'additional_signatory') {
                        data.summary.additional_signatory = {
                            user_uuid: this.form.additional_signatory, 
                            user_name: this.signatories_names_uuid[this.form.additional_signatory] 
                        };
                    } else {
                        data.summary[prop] = this.form[prop]; 
                    }
                }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>

<style scoped>

    .section-title {
        background-color: rgba(200,200,200,0.2);
    }

</style>